//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryEnrollPublicConfig,
  queryEnrollResult,
} from '@/https/crEnroll'

export default {
  components: {},

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      enrollResult: {},
      enrollConfig: {},
    }
  },

  computed: {
    styleBg () {
      const str = this.options && this.options.bjImg ? `url('${this.options.bjImg}')` : ''

      return `backgroundImage: ${str}`
    },
  },

  watch: {
    options: {
      handler (val) {
        if (val) {
          this.queryConfig()
          this.setEnrollResult()
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async queryConfig () {
      const { data } = await queryEnrollPublicConfig()
      this.enrollConfig = data || {}
    },

    async setEnrollResult () {
      const { data } = await queryEnrollResult({
        ksh: this.options.ksh?.trim(),
        zjhm: this.options.zjhm?.trim(),
        xm: this.options.xm?.trim(),
      })

      this.enrollResult = data || {}
    },

    closeDrawer () {
      this.$emit('on-close')
    },
  },
}
